<template>
  <v-dialog
    v-model="showNewDialog"
    scrollable
    content-class="position-absolute top-0"
    eager
    max-width="800px"
  >
    <v-form>
      <v-card class="window-card">
        <v-card-title>
          <span class="md-title" style="color: #67ad5b">模型开发</span>
        </v-card-title>
        <v-card-text style="padding-top: 0px">
          <v-expansion-panels flat :value="showValue">
            <v-expansion-panel>
              <v-expansion-panel-header>申请信息</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-select
                  v-model="formData.model_category"
                  :items="selectMetaListData"
                  label="元件类型"
                  color="#4caf50"
                  readonly
                ></v-select>
                <v-text-field
                  v-model="formData.model_name"
                  label="模型名称"
                  color="#4caf50"
                  readonly
                ></v-text-field>
                <v-select
                  v-model="formData.one_level_classify"
                  :items="selectMajorListData"
                  item-text="name"
                  color="#4caf50"
                  item-value="code"
                  label="专业分类"
                  no-data-text="暂无数据"
                  readonly
                ></v-select>
                <v-select
                  item-text="name"
                  color="#4caf50"
                  item-value="code"
                  no-data-text="暂无数据"
                  label="二级分类"
                  readonly
                ></v-select>
                <v-select
                  item-text="name"
                  color="#4caf50"
                  item-value="code"
                  no-data-text="暂无数据"
                  label="三级分类"
                  readonly
                ></v-select>
                <v-textarea
                  v-model="formData.description"
                  label="模型描述"
                  color="#4caf50"
                  auto-grow
                  readonly
                ></v-textarea>
                <div>
                  <v-subheader>模型图片</v-subheader>
                  <v-img
                    :src="formData.model_image"
                    height="180"
                    contain
                    light
                    position="left left"
                  ></v-img>
                </div>
                <div>
                  <v-subheader>模型全景图片</v-subheader>
                  <v-img
                    :src="formData.model_view_file"
                    height="180"
                    contain
                    light
                    position="left left"
                  ></v-img>
                </div>
                <div>
                  <v-subheader>模型文件</v-subheader>
                  <a
                    :href="formData.model_file"
                    target="_blank"
                    style="padding-left: 15px"
                    >下载</a
                  >
                </div>
                <div>
                  <v-subheader>模型视频资料</v-subheader>
                  <a
                    :href="formData.model_video_file"
                    target="_blank"
                    style="padding-left: 15px"
                    >查看</a
                  >
                </div>
                <div>
                  <v-subheader>模型CAD文件</v-subheader>
                  <a
                    :href="formData.model_cad_file"
                    target="_blank"
                    style="padding-left: 15px"
                    >查看</a
                  >
                </div>
                <v-textarea
                  v-model="formData.model_remark"
                  label="申请备注"
                  color="#4caf50"
                  auto-grow
                  readonly
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>申请记录</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headers"
                  :items="this.applyList"
                  hide-default-footer
                  class="paginated-table table-striped table-hover"
                  no-data-text="暂无数据"
                >
                  <template v-slot:item.status="{ item }">{{
                    statusDict[item.status]
                  }}</template>
                  <template v-slot:item.update_at="{ item }"
                    ><span>{{ dateFormat(item.update_at) }}</span></template
                  >
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>意见回复</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  v-model="auditOpinion"
                  label="内容"
                  auto-grow
                  color="#4caf50"
                  dense
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>驳回理由</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  v-model="rejection"
                  label="内容"
                  auto-grow
                  color="#4caf50"
                  dense
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- <v-expansion-panel>
              <v-expansion-panel-header>作品上传</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-file-input
                  truncate-length="15"
                  label="模型预览图片上传"
                  color="#4caf50"
                  @change="(f) => (form.model_image = fileChange(f))"
                  accept="image/*"
                  show-size
                ></v-file-input>
                <v-file-input
                  truncate-length="15"
                  label="模型上传"
                  color="#4caf50"
                  @change="(f) => (form.model_file = fileChange(f))"
                  show-size
                ></v-file-input>
              </v-expansion-panel-content>
            </v-expansion-panel> -->


          </v-expansion-panels>
        </v-card-text>
        <v-card-actions md-alignment="right" style="margin-right: 0px">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="agree">同 意</v-btn>
          <v-btn class="error" @click="reject">驳 回</v-btn>
          <v-btn color="success" @click="cancel">关 闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      color="red"
      top
    >
 
      请输入驳回理由
    </v-snackbar>
  </v-dialog>
</template>
<script>
import moment from "moment";
import { userInfo } from "@/api/user";
import TriggerVue from '../../../Task/TaskFlow/Trigger.vue';

export default {
  props: {
    showNewDialog: {
      type: Boolean,
      default: false,
    },
    metaListData: {
      type: Array,
      default: [],
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      snackbar:false,
      timeout:2000,
      showValue:0,
      headers: [
        {
          text: "申请/驳回",
          align: "center",
          value: "status",
          sortable: false,
        },
        { text: "意见", align: "center", value: "remark", sortable: false },
        { text: "日期", align: "center", value: "update_at", sortable: false },
        { text: "作者", align: "center", value: "zname", sortable: false },
      ],
      uid: "",
      required: "",
      auditOpinion: "",
      rejection:'',
      form: {},
      // 状态字典
      statusDict: {},
      // 专业分类
      selectMajorListData: [],
      applyList: [],
    };
  },
  components: {},
  created() {
    this.uid = this.$route.query.uid || "";
    //更新状态字典
    this.$dic.getStatusList((res) => {
      this.statusDict = res.reduce((pre, next) => {
        pre[next.index] = next.name;
        return pre;
      }, {});
    });

    // 专业分类
    this.$dic.getCategoryList(
      {
        cate_type: this.formData.model_category,
        level: "1",
      },
      (res) => {
        this.selectMajorListData = res;
      }
    );
    // 申请记录
    this.applyList = [];

    this.formData.apply_list.forEach((item) => {
      let tempData = {
        uid: item.operator,
      };
    

      userInfo(tempData).then((res) => {

        if (res.code === "200") {
          this.applyList.push({ ...item, ...{ zname: res.data.name } });
        }
      });
    });
  },
  computed: {
    selectMetaListData() {
      return this.metaListData.map((item) => {
        return {
          text: item.name,
          value: item.value,
        };
      });
    },
  },
  methods: {
    dateFormat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async fileChange(e) {
      console.log("更改文件", e);
    },
    /**
     * 关闭
     */
    cancel() {
      this.$emit("handleCancel", {});
    },
    /**
     * 反驳
     */
    reject() {

    // --->DevMod
    if(this.rejection==''){
      this.snackbar = true;
      this.showValue = 3;
     return 
    }
      this.$emit("handleReject", { option: this.auditOpinion,rejection:this.rejection });
    },
    /**
     * 通过
     */
    agree() {
     // --->DevMod
      this.$emit("handleAgree", { option: this.auditOpinion });
    },
  },
};
</script>
<style lang="scss" scoped>
.v-card .v-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.img {
  width: 120px;
  height: 180px;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0px;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0px !important;
}
.v-subheader.theme--light {
  padding: 0px;
  height: 30px;
}
.v-expansion-panel-header {
  padding: 16px 0;
  font-weight: 200;
  color: #3c4858 !important;
}
.v-expansion-panel-header--active {
  color: #4caf50 !important;
}
::v-deep
  .v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
  .v-icon {
  color: #4caf50 !important;
}
</style>
